{
    "archives": {
        "title": "Archives"
    }
}